module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-2000-30c97d25efd50b3da9fe56a6e9d10d7b.jpg";